/**
 * Bcx page header component
 *
 * @version
 * 4.70.0 OAUI-678 Build "Driver Assignment" UI
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
import { Component, Input, ViewEncapsulation } from '@angular/core';
@Component({
  selector: 'app-bcx-page-header',
  templateUrl: './bcx-page-header.component.html',
  styleUrls: ['./bcx-page-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BcxPageHeaderComponent {
  @Input() pageTitle = 'Title';
  @Input() pageSubtitle = 'Subtitle';
}
